import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, CheckCircle2, BookOpen, Layers, Target, Award, ArrowRight } from 'lucide-react';
import { CTAButton } from './Shared';
export function PainSection() {
  const pains = ['Domingo a la noche buscando actividades que nunca quedan como querés', 'Clases improvisadas porque no tenés fichas listas ni secuenciadas', 'Alumnos que no participan porque el material es aburrido y genérico', 'Horas perdidas armando debates, casos y consignas desde cero', 'El directivo te pide el proyecto ESI y el EAI y no sabés por dónde empezar', 'Planificaciones anuales que hacés de apuro y que igual te devuelven'];
  return <section className="py-20 bg-white" data-id="element-261">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-262">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-263">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 leading-tight" data-id="element-264">
            Si sos docente de Ciudadanía en secundaria,
            <br data-id="element-265" />
            <span className="text-brand-600" data-id="element-266">esto te va a sonar familiar:</span>
          </h2>
        </motion.div>

        <div className="bg-slate-50 border border-slate-200 rounded-2xl p-6 md:p-10 shadow-sm" data-id="element-267">
          <ul className="space-y-4" data-id="element-268">
            {pains.map((pain, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 text-slate-700 text-lg" data-id="element-269">
                <AlertCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-270" />
                <span data-id="element-271">{pain}</span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center mt-12" data-id="element-272">
          <h3 className="text-2xl font-bold text-slate-900" data-id="element-273">
            ¿Cuántos domingos más vas a perder haciendo lo mismo?
          </h3>
        </motion.div>
      </div>
    </section>;
}
export function ProductOverview() {
  return <section className="py-20 bg-brand-50 border-y border-brand-100" data-id="element-274">
      <div className="container mx-auto px-4 max-w-5xl text-center" data-id="element-275">
        <div className="inline-flex items-center gap-2 bg-brand-100 text-brand-800 px-4 py-1.5 rounded-full font-bold text-sm mb-6" data-id="element-276">
          📚 CIUDADANÍA PACK
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-277">
          El sistema N°1 para docentes de
          <br data-id="element-278" />
          Construcción de Ciudadanía en Argentina
        </h2>
        <h3 className="text-xl md:text-2xl font-bold text-brand-600 mb-12" data-id="element-279">
          MEGAPACK CIUDADANÍA 360
        </h3>

        <div className="grid md:grid-cols-2 gap-12 text-left items-center" data-id="element-280">
          <div className="space-y-6" data-id="element-281">
            {['12 tomos organizados por año (1°, 2° y 3° secundaria)', '180 actividades con secuencia completa', '6 bonus estratégicos', 'Planificaciones anuales listas para presentar', 'Proyectos ESI + EAI listos para firmar', 'Todo listo para usar desde hoy'].map((feature, i) => <div key={i} className="flex items-center gap-3" data-id="element-282">
                <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0" data-id="element-283" />
                <span className="text-lg font-medium text-slate-800" data-id="element-284">
                  {feature}
                </span>
              </div>)}
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-xl border border-slate-100 relative" data-id="element-285">
            <div className="absolute -top-4 -right-4 bg-amber-400 text-slate-900 font-bold px-4 py-2 rounded-lg transform rotate-3 shadow-md" data-id="element-286">
              1° A 3° SECUNDARIA
            </div>
            <div className="flex justify-center gap-4 mb-8" data-id="element-287">
              {['1° AÑO', '2° AÑO', '3° AÑO'].map((year, i) => <div key={i} className="bg-brand-900 text-white font-bold px-4 py-2 rounded-md text-sm" data-id="element-288">
                  {year}
                </div>)}
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-289">
              <div className="bg-slate-50 p-4 rounded-xl text-center border border-slate-100" data-id="element-290">
                <Layers className="w-8 h-8 text-brand-500 mx-auto mb-2" data-id="element-291" />
                <div className="font-bold text-sm text-slate-900" data-id="element-292">
                  12 TOMOS COMPLETOS
                </div>
              </div>
              <div className="bg-slate-50 p-4 rounded-xl text-center border border-slate-100" data-id="element-293">
                <Target className="w-8 h-8 text-brand-500 mx-auto mb-2" data-id="element-294" />
                <div className="font-bold text-sm text-slate-900" data-id="element-295">Por año</div>
              </div>
              <div className="bg-slate-50 p-4 rounded-xl text-center border border-slate-100" data-id="element-296">
                <BookOpen className="w-8 h-8 text-brand-500 mx-auto mb-2" data-id="element-297" />
                <div className="font-bold text-sm text-slate-900" data-id="element-298">
                  Con secuencia didáctica
                </div>
              </div>
              <div className="bg-slate-50 p-4 rounded-xl text-center border border-slate-100" data-id="element-299">
                <Award className="w-8 h-8 text-brand-500 mx-auto mb-2" data-id="element-300" />
                <div className="font-bold text-sm text-slate-900" data-id="element-301">
                  Con evaluación incluida
                </div>
              </div>
            </div>
            <div className="mt-4 bg-amber-50 p-4 rounded-xl text-center border border-amber-200" data-id="element-302">
              <div className="font-bold text-amber-800" data-id="element-303">
                Con 6 bonus estratégicos
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
export function TomosSection() {
  const sections = [{
    badge: 'PRIMER CICLO — 1° AÑO SECUNDARIA',
    headline: '1° Año — 2 Tomos completos',
    tomos: [{
      number: 1,
      title: 'Tomo 1 — 1° Año',
      subtitle: 'Identidad, Derechos y Normas',
      desc: 'Identidad personal, derechos humanos, normas de convivencia y la escuela como institución. 15 actividades listas para imprimir y usar.'
    }, {
      number: 2,
      title: 'Tomo 2 — 1° Año',
      subtitle: 'Ciudadanía, Estado y Participación',
      desc: 'El Estado y sus funciones, formas de participación, resolución de conflictos y vida democrática. 15 actividades listas para imprimir y usar.'
    }]
  }, {
    badge: 'SEGUNDO CICLO — 2° AÑO SECUNDARIA',
    headline: '2° Año — 2 Tomos completos',
    tomos: [{
      number: 3,
      title: 'Tomo 3 — 2° Año',
      subtitle: 'Cultura, Diversidad y Prejuicios',
      desc: 'Concepto de cultura, interculturalidad, estereotipos, discriminación y Ley Antidiscriminatoria. 15 actividades listas para imprimir y usar.'
    }, {
      number: 4,
      title: 'Tomo 4 — 2° Año',
      subtitle: 'Participación Juvenil y Medios',
      desc: 'Jóvenes y política, medios de comunicación, fake news, redes sociales y ciudadanía digital. 15 actividades listas para imprimir y usar.'
    }]
  }, {
    badge: 'TERCER CICLO — 3° AÑO SECUNDARIA',
    headline: '3° Año — 2 Tomos completos',
    tomos: [{
      number: 5,
      title: 'Tomo 5 — 3° Año',
      subtitle: 'Estado, Democracia y Trabajo',
      desc: 'Estado de Derecho, democracia participativa, derechos laborales, movimiento obrero y economía social. 15 actividades listas para imprimir y usar.'
    }, {
      number: 6,
      title: 'Tomo 6 — 3° Año',
      subtitle: 'Derechos, Género y Futuro Ciudadano',
      desc: 'Género, diversidad sexual, violencia de género, medio ambiente y desafíos del siglo XXI. 15 actividades listas para imprimir y usar.'
    }]
  }];
  return <section className="py-20 bg-white" data-id="element-304">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-305">
        {sections.map((section, idx) => <div key={idx} className="mb-20 last:mb-0" data-id="element-306">
            <div className="text-center mb-10" data-id="element-307">
              <span className="text-sm font-bold tracking-wider text-brand-600 uppercase bg-brand-50 px-4 py-2 rounded-full" data-id="element-308">
                {section.badge}
              </span>
              <h3 className="text-3xl font-bold text-slate-900 mt-6" data-id="element-309">
                {section.headline}
              </h3>
            </div>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-310">
              {section.tomos.map((tomo, i) => <motion.div key={i} whileHover={{
            y: -5
          }} className="bg-white border-2 border-slate-100 rounded-2xl p-8 shadow-lg hover:shadow-xl hover:border-brand-200 transition-all relative overflow-hidden" data-id="element-311">
                  <div className="absolute -right-6 -top-6 text-9xl font-black text-slate-50 opacity-50 select-none" data-id="element-312">
                    {tomo.number}
                  </div>
                  <div className="relative z-10" data-id="element-313">
                    <div className="text-brand-600 font-bold mb-2" data-id="element-314">
                      {tomo.title}
                    </div>
                    <h4 className="text-xl font-bold text-slate-900 mb-4" data-id="element-315">
                      {tomo.subtitle}
                    </h4>
                    <p className="text-slate-600 leading-relaxed" data-id="element-316">
                      {tomo.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>

            {idx !== sections.length - 1 && <div className="w-full max-w-xs mx-auto h-px bg-slate-200 mt-20" data-id="element-317"></div>}
          </div>)}
      </div>
    </section>;
}
export function WhatIncluded() {
  const features = ['15 actividades listas para imprimir y entregar', 'Consignas claras que el alumno entiende solo', 'Diseño en blanco y negro optimizado para fotocopiadora', 'Debates guiados con disparadores listos', 'Casos reales para analizar en clase', 'Trabajo integrador de cierre por tomo', 'Autoevaluación del alumno incluida', 'Alineado al currículo argentino 2026'];
  return <section className="py-20 bg-slate-900 text-white" data-id="element-318">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-319">
        <div className="bg-slate-800 rounded-3xl p-8 md:p-12 border border-slate-700 shadow-2xl" data-id="element-320">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-321">
            Cada tomo incluye:
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-322">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-3 bg-slate-700/50 p-4 rounded-xl" data-id="element-323">
                <div className="bg-green-500/20 p-1 rounded-full shrink-0" data-id="element-324">
                  <CheckCircle2 className="w-5 h-5 text-green-400" data-id="element-325" />
                </div>
                <span className="text-slate-200 font-medium" data-id="element-326">{feature}</span>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-327">
            <CTAButton className="mx-auto" data-id="element-328">
              🔥 RESERVÁ TU PACK AL PRECIO DE LANZAMIENTO
            </CTAButton>
          </div>
        </div>
      </div>
    </section>;
}